import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

interface C1ShellProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  as?: 'main' | 'div' | 'section';
}

/** Constrains content to the C1 card max-width (920px). */
export function C1Shell({ children, as: Tag = 'main', className, ...props }: C1ShellProps) {
  return (
    <Tag className={cx('c1-shell', className)} {...props}>
      {children}
    </Tag>
  );
}
